<template>
  <div class="comments">
    <div v-if="comments !== undefined">
      <Comment
        v-for="comment in topLevelComments"
        v-bind:key="comment.parent.id"
        :author="comment.parent.author_name"
        :author-slug="comment.parent.author"
        :parent-comment-id="comment.parent.id"
        :date="comment.parent.date"
        :content="comment.parent.content.rendered"
        :replies="comment.children"
        country="http://thinktank.punctu8.co.za/wp-content/themes/blankslate/images/flag-kenya.svg"
        :authorPic="comment.parent.author_avatar_urls['96']"
        :post-id="comment.parent.post"
        :show-post="showPost"
        :text-box-reference="'commentText' + postId"
        v-on:setCommentParent="setParentCommentID($event)">
      </Comment>
    </div>
    <div v-if="!showPost">
      <b-alert v-if="commentAdded.show" show dismissible :variant="commentAdded.variant">
        {{commentAdded.message}}
      </b-alert>
      <label :for="'commentText' + postId"><h5>Add a Comment</h5></label>
      <div class="form-group">
        <textarea class="form-control" rows="2" :id="'commentText' + postId" v-model="commentText"></textarea>
        <br>
        <button type="submit" class="btn btn-primary" v-on:click="addComment()" :disabled="commentText.length === 0">Add comment</button>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '@/components/Comment'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  props: [
    'comments',
    'showPost',
    'ignoreNesting',
    'postId'
  ],
  data () {
    return {
      commentText: '',
      parentComment: null,
      commentAdded: {show: false, message: '', variant: ''}
    }
  },
  components: {
    Comment
  },
  computed: {
    verifiedParentCommentID: function () {
      if (this.parentComment === null) {
        return 0
      } else {
        return this.parentComment
      }
    },
    topLevelComments: function () {
      var parentComments = []
      if (this.ignoreNesting) {
        for (var i = 0; i < this.comments[0].length; i++) {
          parentComments.push({
            parent: this.comments[0][i],
            children: []
          })
        }
      } else {
        for (var j = 0; j < this.comments[0].length; j++) {
          if (this.comments[0][j].parent === 0) {
            parentComments.push({
              parent: this.comments[0][j],
              children: this.comments[0].filter(x => x.parent === this.comments[0][j].id)
            })
          }
        }
      }
      return parentComments
    }
  },
  methods: {
    setParentCommentID: function (id) {
      this.parentComment = id
    },
    addComment: function () {
      var self = this
      var createComment = {
        method: 'POST',
        data: {
          author: this.$store.state.UserProfile.currentUser.id,
          content: this.commentText,
          parent: this.verifiedParentCommentID,
          post: this.postId,
          status: 'publish'
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      WordpressRestAPI.endpointWithAuthetication(createComment, 'comments')
        .then(function (response) {
          console.log(response.data)
          console.log(response.status)
          self.commentAdded = {show: true, message: 'Your comment has been added', variant: 'success'}
        })
        .catch(function (e) {
          console.error(e)
          self.commentAdded = {show: true, message: 'Oops, there was an error adding your comment', variant: 'danger'}
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Comments.vue